<template>
  <AccessCodePaymentAuditModal
    :is-open="isModalOpen"
    :reload="reload"
    :close="modalCode"
    :accessCodePaymentType="accessCodePaymentType"
  />
  <div>
    <div class="p-0">
      <b-card>
        <h4 class="text-2xl font-semibold text-gray-700">{{`${paymentCount}/${totalCount}`}}</h4>
        <div class="text-gray-500">결제자 수/총 학생수</div>
      </b-card>
    </div>
    <div class="inline-block min-width-full rounded-lg shadow bg-white p-4 my-3">
      <div class="my-2">
        <b-input-group class="max-w-2xl">
          <b-form-input
            id="inline-form-input-name"
            class=" mr-sm-2 md-4"
            placeholder="이름 또는 학생코드, 전화번호를 입력하세요."
            v-model="search.keyword"
            v-on:keyup.enter="handleSearch"
          ></b-form-input>
          <b-input-group-append>
            <button class="btn btn-primary" v-on:click="handleSearch">검색</button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div class="flex align-items-end justify-content-start gap-2 flex-nowrap mb-4 bg-white">
        <Button :type="ButtonTypes.blue" :label="this.accessCodePaymentType === 'BASIC_CLASS' ? '기초반 기준값 업데이트' : '실전반 기준값 업데이트' " :onClick="clickFileUpload" :loading="uploadButtonLoading"/>
        <input
          type="file"
          ref="fileInput"
          class="hidden"
          accept=".xls,.xlsx"
          @change="upload"
        />
        <Button :type="ButtonTypes.purple" :label="this.accessCodePaymentType === 'BASIC_CLASS' ? '기초반 학생 등록' : '실전반 학생 등록'" :onClick="modalCode"/>
        <Button :type="ButtonTypes.green" label="결제정보 다운로드" :onClick="download" :loading="downloadButtonLoading"/>
      </div>
      <p class="text-rose-600 text-xl font-bold">기준값 업데이트를 하게 되면 모든 데이터가 리셋됩니다. 주의해주세요.</p>
      <div v-if="isLoading" class="text-center">
        <p>데이터를 불러오는 중입니다...</p>
        <b-spinner label="Loading..."/>
      </div>
      <b-table-simple v-else class="min-width-full">
        <b-thead>
          <b-tr>
            <b-th>번호</b-th>
            <b-th>학생 코드</b-th>
            <b-th>이름</b-th>
            <b-th class="min-w-[130px]">전화번호</b-th>
            <b-th>주문번호</b-th>
            <b-th>가격</b-th>
            <b-th>결제일시</b-th>
            <b-th class="min-w-[40px] md:min-w-0">오프라인 수강 신청</b-th>
            <b-th class="min-w-[200px]">(필수) 수업</b-th>
            <b-th class="min-w-[200px]">(옵션) 수업</b-th>
            <b-th>할인 내용</b-th>
            <b-th></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="(item, parentIndex) in payments" :key="parentIndex">
            <b-tr v-if="item.list.length === 0">
              <td>{{ generateRowNumbers(parentIndex) }}</td>
              <td>{{ item.accessCode }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.phoneNumber }}</td>
              <td colspan="7" class="text-center"></td>
              <td>
                <div class="inline-flex gap-2 justify-center">
                  <Button :type="ButtonTypes.red" label="삭제" :on-click="() => {deleteItem(item.id)}"/>
                </div>
              </td>
            </b-tr>
            <b-tr v-for="(subItem, index) in item.list" :key="index">
              <template v-if="index === 0">
                <td :rowspan="item.list.length">{{ generateRowNumbers(parentIndex) }}</td>
                <td :rowspan="item.list.length">{{ item.accessCode }}</td>
                <td :rowspan="item.list.length">{{ item.name }}</td>
                <td :rowspan="item.list.length">{{ item.phoneNumber }}</td>
              </template>
              <td class="text-center">{{ subItem.paymentKey }}</td>
              <td class="text-center">{{ `${subItem.amount.toLocaleString()}원` }}</td>
              <td class="text-center">{{ getDate(subItem.paidAt) }}</td>
              <td class="text-center">{{ subItem.offlineClass }}</td>
              <td class="text-center">{{ subItem.productLessonTitle }}</td>
              <td class="text-center">{{ subItem.productLessonOptionTitle }}</td>
              <td class="text-center">{{ subItem.productLessonDiscountTitle }}</td>
              <template v-if="index === 0">
                <td :rowspan="item.list.length">
                  <div class="inline-flex gap-2 justify-center">
                    <Button v-if="item.type === 'BULK_UPLOAD' " :type="ButtonTypes.yellow" label="리셋" :on-click="() => {reset(item.id)}"/>
                    <Button :type="ButtonTypes.red" label="삭제" :on-click="() => {deleteItem(item.id)}"/>
                  </div>
                </td>
              </template>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
      <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        @page-click="changePage"
      />
    </div>
  </div>
</template>
<script>
import api from "@/api/api";
import customDate from "@/util/custom-date";
import {copyText} from "vue3-clipboard";
import Button from "@/components/Button.vue";
import {ButtonTypes} from "@/util/enums";
import AccessCodePaymentAuditModal from "@/components/modals/AccessCodePaymentAuditModal.vue";
import {mapActions} from "vuex";

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    }
  },
  components: {AccessCodePaymentAuditModal, Button},
  props: ['accessCodePaymentType'],
  data() {
    return {
      isModalOpen: false,
      payments: [],
      isLoading: false,
      uploadButtonLoading: false,
      downloadButtonLoading: false,
      search: {
        keyword: "",
      },
      file: null,
      totalCount: 0,
      paymentCount: 0,
      currentPage: 1,
      pageSize:30,
      totalPage: 0,
      totalRows: 0,
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.keyword) {
      this.search.keyword = query.keyword
    }
    
    this.payments = []
    this.get(this.currentPage)
    this.getCount()
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    reload() {
      this.currentPage = 1
      this.updateQueryParams()
      this.get(1)
      this.getCount()
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.get(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.keyword) {
        query.keyword = this.search.keyword
      }
      
      this.$router.replace({ query })
    },
    generateRowNumbers(index) {
      return (this.currentPage - 1) * 30 + (index + 1)
    },
    modalCode () {
      this.isModalOpen = !this.isModalOpen
    },
    getCount () {
      const params = {
        accessCodePaymentType: this.accessCodePaymentType,
      }
      api.accessCodePaymentAudit.getCount(params, (response) => {
        const {totalCount, paymentCount} = response.data
        this.totalCount = totalCount
        this.paymentCount = paymentCount
      })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    download() {
      const params = {
        accessCodePaymentType: this.accessCodePaymentType,
        searchKeyword: this.search.keyword || "",
      }
      this.downloadButtonLoading = true
      api.accessCodePaymentAudit.download(params, (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${this.type === "BASIC_CLASS" ? "기초반": "실전반"}_결제내역_${new Date().toISOString()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.downloadButtonLoading = false
      })
    },
    clickFileUpload() {
      this.openModal({
        type: 'confirm',
        isOpen: true,
        title: '기준값 업데이트',
        html: '<p class="text-rose-600 break-words">기준값 업데이트를 하게 되면 모든 데이터가 리셋됩니다.<br/> 진행하시겠습니까?</p>',
        confirm: () => {
          this.$refs.fileInput.click()
        },
      });
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.get(this.currentPage)
    },
    upload(event) {
      const uploadFile = event.target.files[0];
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel' // .xls
      ];

      if (!validTypes.includes(uploadFile.type)) {
        this.$toast.show('엑셀 형식만 올릴 수 있습니다.',
          {
            position: "top-right",
            duration: 2000
          });
        event.target.value = null;
        return
      } else {
        this.file = uploadFile
      }

      let formData = new FormData()
      formData.append('file', this.file, this.file.name)
      formData.append('accessCodePaymentType',this.accessCodePaymentType)
      this.uploadButtonLoading = true
      api.accessCodePaymentAudit.upload( formData, (response) => {
        const {data} = response.data
        if (data.length > 0) {
          this.$toast.show(`존재하지 않는 학생 코드가 존재합니다. \n 학생 코드 : ${data.toString()}`,
            {
              position: "top-right",
              duration: 12000
            });
        }
        this.get(this.type)
        this.$refs.fileInput.value = null;
        this.uploadButtonLoading = false
      }, (e) => {
        console.error(e)
      })
    },
    reset(id) {
      this.isLoading = true
      api.accessCodePaymentAudit.reset(id, () => {
        this.get(this.currentPage)
      },  (error) => {
        console.log(error)
      })
    },
    deleteItem(id) {
      this.isLoading = true
      api.accessCodePaymentAudit.delete(id, () => {
        this.get(this.currentPage)
      },  (error) => {
        console.log(error)
      })
    },
    get(page = 1) {
      this.isLoading = true
      this.payments = []
      api.accessCodePaymentAudit.search({
        accessCodePaymentType:  this.accessCodePaymentType,
        searchKeyword: this.search.keyword || "",
        page: page,
      },(response) => {
        const {content, totalElements, totalPages} = response.data
        this.payments = content
        this.totalRows = totalElements
        this.totalPage = totalPages
        this.currentPage = page
        this.isLoading = false
      }, (err) => {
        console.log(err)
      })
    },
  },
}
</script>

